import { defaultSapVatCode } from '@repo/utils/vat';
import type { AssortmentProduct } from '@/server/assortments/assortment-products';

export function formatSapCreationData(product: AssortmentProduct) {
  return {
    DeliveryWeek1: '',
    DeliveryWeek2: '',
    DeliveryWeek3: '',
    DeliveryWeek4: '',
    DeliveryWeek5: '',
    DeliveryWeek6: '',
    DeliveryWeek7: '',
    DeliveryWeek8: '',
    BaseUomEan: '',
    ExternalMerchandiseCategory: product.teksoProductGroup || '',
    OrderUnitEan: '',
    TaxCode: product.vatId || defaultSapVatCode,
    TaxClassification: product.taxClass || '',
    VendorMaterialNumber: product.productCode || '',
    MaterialCategory: '01',
    MerchandiseCategory: product.sapProductGroup || '',
    GeneralItemCategoryGroup: product.generalItemCategoryGroup || '',
    BaseUnitOfMeasure: product.baseUnit || '',
    OrderUnit: product.orderUnit || '',
    ConversionNumberToBaseUom: product.orderUnitAmount || '1',
    SeasonYear: product.seasonYear,
    SeasonCategory: product.seasonCategory || '',
    SeasonalArticleCategory: product.seasonalArticleCategory || '',
    CommodityImportCode: product.cnNumber || '',
    CountryOfOrigin: product.country || '',
    SportBrand: product.brandBraCode || '',
    ArticleRole: '',
    AssortmentImpact: '',
    VendorNumber: product.vendorNumber || '',
    PlannedDeliveryTimeInDays: product.deliveryTime || '',
    PurchasingGroup: product.purchasingGroup || 'U99',
    DistributionProfile: product.distributionProfile || '',
    StorageLocation: product.storageLocation || '',
    Plant: product.plant || '',
    NetPrice: product.sapNetPrice || '',
    Currency: product.currency || 'EUR',
    EndCustomerFinalPrice: product.endCustomerFinalPrice,
    WholesalesFinalPrice: product.wholesalesFinalPrice,
    Weight: product.weight || '',
    Height: product.height || '',
    Width: product.width || '',
    Length: product.length || '',
    Depth: product.depth || '',
    Volume: product.volume || '',
    Circumference: product.circumference || '',
    Diameter: product.diameter || '',
    ArticleDescriptionForUnitOfMeasures: [
      {
        Language: 'FI',
        UnitOfMeasure: product.baseUnit || '',
        Description: product.receiptProductName
          ? `${product.brandSapAbbreviation} ${product.receiptProductName || ''}`
              .substring(0, 18)
              .toUpperCase()
          : '',
      },
    ],
    ArticleDescriptions: [
      {
        Language: 'FI',
        Description:
          `${product.brandSapAbbreviation} ${product.sapName || ''}`
            .substring(0, 40)
            .toUpperCase() || '',
      },
      {
        Language: 'EN',
        Description:
          `${product.brandSapAbbreviation} ${product.sapName || ''}`
            .substring(0, 40)
            .toUpperCase() || '',
      },
    ],
    Layouts: [
      {
        LayoutModule: product.layoutModule || '',
        UnitOfMeasure: product.baseUnit || '',
      },
    ],
    SalesData: ['U1', 'U2', 'U3', 'U4'].map((key) => ({
      DistributionChannel: key,
      SalesFlag: true,
      ItemCategory: product.generalItemCategoryGroup || '',
    })),
    SizesAndColors: Object.keys(product.productSizesColorMapped).reduce<
      { Ean: string; Color: string; Size: string }[]
    >((acc, key) => {
      const color = product.productSizesColorMapped[key];
      if (!color) {
        return acc;
      }
      return [
        ...acc,
        ...color.items
          .filter((size) => size.sapEnabled && !size.sapId)
          .map((size) => ({
            Ean: size.ean,
            Color: `${color.colorSapCode || color.b24ColorSapCode}=${color.colorName}`,
            Size: size.size,
          })),
      ];
    }, []),
  };
}

export type SapCreationDataFormatted = ReturnType<typeof formatSapCreationData>;
